import WorkflowStepValidation from "./workflowStepValidation";
import CertificateStep from "../../../formability/form_builder/models/workflow/certificateStep";
import WorkflowStepLinkedDocumentValidator from "../navigableValidators/workflowStepLinkedDocumentValidator";
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";

export default class CertificateStepValidation extends WorkflowStepValidation<CertificateStep> {
  validators = new WorkflowStepValidation(this.model).validators.concat([
    new WorkflowStepLinkedDocumentValidator({
      validatorKey: "certificate",
      section: ValidationModalSection.Workflow
    }),
  ]);

  protected getAnchorHash(field: string, value?): string {
    return "certificate-search";
  }
}